<template>
  <head>
    <title>
      {{ $t("whyUs") }}
    </title>
  </head>
  <div class="services-view">
    <AdminSidebar>
      <TableComponent
        :titles="titles"
        :data="data"
        :title="title"
        :pageUrl="pageUrl"
        deleteApi="api/delete_service"
        EditUrl="/update-service"
      />
    </AdminSidebar>
  </div>
</template>

<script>
import store from "@/store";
import axios from "axios";
import AdminSidebar from "@/components/AdminDashboard/AdminSidebar.vue";
import TableComponent from "@/components/AdminDashboard/TableComponent.vue";

export default {
  name: "services-view",
  data() {
    return {
      data: {},
      ErrorMessage: "",
      titles: [
        "id",
        "name_en",
        "name_ar",
        "description_ar",
        "description_en",
        "delete",
        "update",
        "show",
      ],
      title: "whyUs",
      pageUrl: "AddService",
    };
  },
  methods: {
    getData() {
      store.state.loading_state = 1;
      axios
        .get(store.state.server + "api/get_all_service")
        .then((response) => {
          this.data = response.data;
          store.state.loading_state = 0;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getData();
  },
  components: {
    AdminSidebar,
    TableComponent,
  },
};
</script>
